var _path, _path2, _circle, _path3, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfesionalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.811 2.82605C5.16948 3.1304 2.92416 5.56516 2.92416 5.56516V16.9781M20.2452 2.82605C21.0471 3.43474 22.8434 4.83473 23.6132 5.56516V17.8912M23.6132 17.8912C23.6132 17.8912 23.4404 17.4346 22.195 17.8912M23.6132 17.8912C23.6132 17.8912 24.3518 17.3203 24.9175 17.8912M10.1413 29.559C11.1598 29.7827 12.2798 29.8621 13.5093 29.7606C14.3663 29.6899 15.1672 29.5559 15.915 29.3681M10.1413 29.559V33.8693C10.3017 34.1736 10.8149 34.7823 11.5847 34.7823C11.9241 34.7823 12.4629 34.7823 13.0281 34.7823M10.1413 29.559C4.10304 28.2327 1.56715 23.2409 1 19.3603C1 18.3403 1.82873 17.4346 2.19321 17.4346H3.79005C4.06006 17.3203 5.05159 19.1803 5.08008 19.3603C5.55202 22.3427 7.68306 26.454 13.5093 26.1085C19.6679 25.7433 21.24 21.9473 21.4004 19.3603C21.4004 19.3603 21.4004 18.3403 22.195 17.8912M15.915 29.3681C22.8913 27.6165 24.9175 23 25.4805 19.3603C25.4805 19.3603 25.3718 18.3403 24.9175 17.8912M15.915 29.3681C15.915 30.7163 15.915 33.5041 15.915 33.8693C15.915 34.2345 15.2734 34.6302 14.9527 34.7823C14.5043 34.7823 13.745 34.7823 13.0281 34.7823M13.0281 34.7823C13.0281 39.0432 15.1451 47.3822 23.6132 46.6518C32.0813 45.9214 33.236 37.8258 32.7549 33.8693V20.1737C32.9153 18.3477 34.4722 14.239 39.4909 14.239C44.7834 14.239 45.7457 18.0433 45.7457 20.1737V21.9998M22.195 17.8912C23.3007 17.8912 23.8119 17.8912 24.9175 17.8912",
    stroke: "#F9F9F9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3005 27.4781C51.3005 30.0828 49.064 32.2563 46.2268 32.2563C43.3896 32.2563 41.1531 30.0828 41.1531 27.4781C41.1531 24.8734 43.3896 22.6999 46.2268 22.6999C49.064 22.6999 51.3005 24.8734 51.3005 27.4781Z",
    stroke: "#F9F9F9",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 2,
    r: 1.4,
    stroke: "#F9F9F9",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6524 27.4781C47.6524 28.1861 47.0396 28.8042 46.2278 28.8042C45.4159 28.8042 44.8032 28.1861 44.8032 27.4781C44.8032 26.7702 45.4159 26.152 46.2278 26.152C47.0396 26.152 47.6524 26.7702 47.6524 27.4781Z",
    stroke: "#F9F9F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 2,
    r: 1.4,
    stroke: "#F9F9F9",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfesionalIcon);
export default __webpack_public_path__ + "static/media/profesional-icon.b2eb6ce647fe491c495e802c197279d9.svg";
export { ForwardRef as ReactComponent };